<section class="downloads-panel">
  <h3 class="mb-2" i18n>Product Downloads</h3>
  <p class="mb-3" i18n>Explore the latest downloads for Ping Identity products.</p>

  @if (loading) {
    <div class="row g-4">
      @for (_ of loadingCards; track $index) {
        <div class="col-12 col-md-6 col-xl-4 d-flex">
          <backstage-card-alt [loading]="true" class="d-block h-100 w-100"/>
        </div>
      }
    </div>
  } @else if (pages.length) {
    <div class="row g-4">
      @for (page of pages; track page.path) {
        <div class="col-12 col-md-6 col-xl-4 d-flex">
          <backstage-card-alt class="w-100 h-100">
            <backstage-product-icon card-icon [productId]="getProductId(page.path)" [height]="3" [width]="3"/>
            <span card-title>{{ page.title }}</span>
            <span card-description>{{ page.synopsis }}</span>
            <a card-footer class="btn-link p-0 text-decoration-none" [href]="page.jumpTo || downloadsUrl + '/browse/' + page.path + '/featured'" i18n>
              Learn more <i class="bi bi-chevron-right ms-1" aria-hidden="true"></i>
            </a>
          </backstage-card-alt>
        </div>
      }
    </div>
  } @else {
    <div class="downloads-panel-empty">
      @if (failed) {
        <p class="mb-2" i18n>Featured downloads are unavailable right now.</p>
      } @else {
        <p class="mb-2" i18n>No featured downloads are currently available.</p>
      }
      <a class="btn-link p-0 text-decoration-none" [href]="downloadsUrl" i18n>
        Browse all downloads <i class="bi bi-chevron-right ms-1" aria-hidden="true"></i>
      </a>
    </div>
  }
</section>
